export default __webpack_public_path__ + "static/media/PuntoAzulVacio.016f593c.png";